"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validateForm;
var _helpers = require("./helpers");
var _combine = require("./combine");
function validateForm(validations) {
  /* istanbul ignore next */
  return function () {
    return process(validations, arguments);
  };
}
function process(validations, args, keys) {
  var errors = {};
  for (var attr in validations) {
    if (_helpers.HAS_PROP.call(validations, attr) && validations[attr]) {
      var attrKeys = keys ? keys.concat(attr) : [attr];
      errors[attr] = (0, _helpers.isObject)(validations[attr]) ? process(validations[attr], args, attrKeys) : (0, _combine.firstErr)([].concat(validations[attr])).apply(null, [].concat((0, _helpers.getIn)(args[0], attrKeys), args));
    }
  }
  return errors;
}